import { BorderedImage } from "@baseComponents/BorderedImage";
import { Header } from "@baseComponents/Header";
import { MetricCard } from "@baseComponents/MetricCard";

import { StatsGrid } from "./PortfolioHeader.styled";

interface PortfolioHeaderProps {
  title: string;
  image: string;
  alt: string;
  stats: { primary: string; secondary: string }[];
}

export const PortfolioHeader = ({
  title,
  image,
  alt,
  stats,
}: PortfolioHeaderProps) => {
  return (
    <div className="align-center mb-8">
      <Header header={title} withoutPadding variant="caseStudy" />

      <div className="h-4" />

      <BorderedImage src={image} alt={alt} />

      <div className="h-8" />

      <StatsGrid>
        {stats.map((stat, index) => (
          <MetricCard
            key={index}
            main={stat.primary}
            secondary={stat.secondary}
          />
        ))}
      </StatsGrid>

      <div className="h-4" />
    </div>
  );
};
